import * as apis from "../../network/apis/packages";
import { call, put } from "redux-saga/effects";
import {
  getAllPackagesRequest,
  getAllPackagesResponse,
  getSinglePackageResponse
} from "./actions";
// import messages from "../../assets/locale/messages";
import { showHideSnackbar } from "../Snackbar/actions";
import { ROUTE_PATHS } from "../../utils/PathsNames";
import history from "../../routes/History";

export function* getAllPackagesSage() {
  try {
    const response = yield call(apis.getAllPackages);
    yield put(getAllPackagesResponse(response.data.packages));
  } catch (err) {
    console.error(err);
  }
}

export function* addNewPackageSaga({ payload }) {
  try {
    // const
    const response = yield call(apis.addNewPackage, payload);
    console.log("response", response);

    yield put(
      showHideSnackbar({
        isOpen: true,
        message: "package is added successfully.",
        type: "success"
      })
    );
    yield history.push(ROUTE_PATHS.packages);
  } catch (err) {
    console.error(err);
  }
}

export function* getSinglePackageSaga({ payload }) {
  try {
    const response = yield call(apis.getSinglePackage, payload);
    yield put(
      getSinglePackageResponse({
        package: response.data.package
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export function* editPackageSaga({ payload }) {
  console.log("payload", payload);
  try {
    const response = yield call(apis.editPackage, payload);
    console.log("res", response);

    yield put(
      showHideSnackbar({
        isOpen: true,
        message: "package is updated successfully.",
        type: "success"
      })
    );
    yield history.push(ROUTE_PATHS.packages);
  } catch (err) {
    console.error(err);
  }
}

export function* deletePackageSaga({ payload }) {
  try {
    yield call(apis.deletePackage, payload);
    yield put(
      showHideSnackbar({
        isOpen: true,
        message: "package is deleted successfully.",
        type: "success"
      })
    );
    yield put(getAllPackagesRequest());
  } catch (err) {
    console.error(err);
  }
}
